import { SearchableSelectType } from '../inputs/searchableSelect';

export interface ToggleButtonFilterProps extends SearchableSelectType {
    isLeft?: boolean;
    isRight?: boolean;
    className?: string;
}

export enum TableFilterType {
    DROPDOWN = 'dropdown',
    TOGGLE_BUTTONS = 'toggle_buttons',
    MULTISELECT = 'multiselect',
}

export type SearchProps = {
    placeholder?: string;
};

type DropDownMetaOptions = {
    options?: SearchableSelectType[] | ToggleButtonFilterProps[];
    filterType?: 'startsWith' | 'equal' | 'contains';
};

export type TableFilterConfig = {
    type: TableFilterType;
    field: string;
    label?: string;
    placeholder?: string;
    setQueryParamsOnly?: boolean;
    cellDataType?: 'text' | 'number' | 'dateString';
    meta?: DropDownMetaOptions;
    defaultValue?: SearchableSelectType | SearchableSelectType[];
    showFilterChip?: boolean;
};
